export class User {
    constructor(_id,email,name,username,dp,role,mobileNumber,fcmToken) {
        this._id = _id
        this.email = email;
        this.name = name;
        this.username = username;
        this.dp = dp;
        this.role = role;
        this.mobileNumber = mobileNumber;
        this.fcmToken = fcmToken
    }
}